/* eslint-disable react-hooks/exhaustive-deps */
import { produce } from "immer";
import FormFieldWithLabel from "../FormFieldWithLabel/FormFieldWithLabel";
import { useState, useEffect } from "react";
import "./QIInventoryListInput.scss";
import { useFetchInventoryList } from "../../hooks/fetchInventoryList";
import { ReactComponent as NodataIcon } from "../../assets/icons/no-data.svg";
import { useSelectVehicleContext } from "../../contexts/selectVehicleContext";

function QuizInputList({
  filteredInventoryList,
  editAndFilterInputValue,
  inventoryListRequestPending,
  inventoryList,
}) {
  function handleMouseDownEv(input, avgBaseMSRP = 0, fromInventory = true) {
    editAndFilterInputValue(input, avgBaseMSRP, fromInventory, true);
  }

  function buildUserChoiceQueryStr(
    year = "",
    make = "",
    model = "",
    trim = ""
  ) {
    const data = {
      year,
      make,
      model,
      ...(trim?.length > 0 ? { trim } : {}),
    };

    const queryString = new URLSearchParams(data).toString();

    return queryString;
  }

  return (
    <>
      {inventoryListRequestPending ? (
        <div className="quiz-input-list-menu">
          {Array.from({ length: 2 }).map((_, index) => (
            <div key={index} className="quiz-input-list-item">
              <span className="quiz-input-list-circle-item-mock skeleton"></span>
              <span className="quiz-input-list-square-item-mock skeleton"></span>
            </div>
          ))}
          <div>
            {filteredInventoryList.map((item, index) => (
              <div key={index}>
                {item.trims && item.trims.length === 0 && (
                  <div
                    onMouseDown={() => handleMouseDownEv(item.carName, false)}
                    className="quiz-input-list-item"
                  >
                    {`Other: ${item.carName}`}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="quiz-input-list-menu">
          {inventoryList?.length === 0 && (
            <>
              <div className="inventory-menu-status">
                <NodataIcon />
                <p>Inventory Not Available!</p>
              </div>
              <div className="inventory-menu-divider"></div>
            </>
          )}
          <div>
            {filteredInventoryList.map((item, index) => (
              <div key={index}>
                {item.trims && item.trims.length === 1 && (
                  <div
                    onMouseDown={() =>
                      handleMouseDownEv(
                        buildUserChoiceQueryStr(
                          item.year,
                          item.make,
                          item.model,
                          item.trims[0]
                        ),
                        item.avgBaseMSRP
                      )
                    }
                    className="quiz-input-list-item"
                  >
                    {item.carName}
                    <span className="sub-item">{item.trims[0]}</span>
                  </div>
                )}
                {item.trims && item.trims.length > 1 && (
                  <div
                    onMouseDown={() =>
                      handleMouseDownEv(
                        buildUserChoiceQueryStr(
                          item.year,
                          item.make,
                          item.model
                        ),
                        item.avgBaseMSRP
                      )
                    }
                    className="quiz-input-list-item"
                  >
                    {item.carName}
                  </div>
                )}
                {item.trims && item.trims.length > 1 && (
                  <div className="quiz-input-list-sublist">
                    {item.trims.map((trim, subIndex) => {
                      return (
                        <div key={subIndex}>
                          {trim ? (
                            <div
                              onMouseDown={() =>
                                handleMouseDownEv(
                                  buildUserChoiceQueryStr(
                                    item.year,
                                    item.make,
                                    item.model,
                                    trim
                                  ),
                                  item.avgBaseMSRP
                                )
                              }
                              className="quiz-input-list-item sub-item"
                            >
                              {trim}
                            </div>
                          ) : null}
                        </div>
                      );
                    })}
                  </div>
                )}
                {item.trims && item.trims.length === 0 && (
                  <div
                    onMouseDown={() =>
                      handleMouseDownEv(item.carName, item.avgBaseMSRP, false)
                    }
                    className="quiz-input-list-item"
                  >
                    {`Other: ${item.carName}`}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default function QIInventoryListInput({
  currentQuestionViewIndex,
  childIndex,
  quizQuestions,
  setQuizQuestions,
}) {
  const getUserDropdownValue = (inputValue) => {
    return {
      carName: inputValue,
      year: "",
      make: "",
      model: "",
      trims: [],
      avgBaseMSRP: 0,
    };
  };

  const { handleVehicleVPOG } = useSelectVehicleContext();

  const [inventoryList, setInventoryList] = useState([]);
  const [inventoryListRequestPending, setInventoryListRequestPending] =
    useState(true);
  const [filteredInventoryList, setFilteredInventoryList] = useState([
    getUserDropdownValue(""),
  ]);
  const [inventoryListShow, setInventoryListShow] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const inputErrorMessage =
    quizQuestions[currentQuestionViewIndex].children[childIndex]
      .inputErrorMessage;

  const [valueFromDropdownSelected, setValueFromDropSelected] = useState(true);
  useFetchInventoryList(setInventoryList, setInventoryListRequestPending);

  const openDropdown = () => {
    setInventoryListShow(true);
  };

  const closeDropdown = () => {
    setInventoryListShow(false);
    const isInputError = !valueFromDropdownSelected && inputValue?.length > 0;
    setErrorMessage(isInputError ? inputErrorMessage : "");
    setQuizQuestions(
      produce((quizQuestionsDraft) => {
        const curentQuestionsDraft =
          quizQuestionsDraft[currentQuestionViewIndex].children[childIndex];
        curentQuestionsDraft.inputError = isInputError;
      })
    );
  };

  useEffect(() => {
    const inputError =
      quizQuestions[currentQuestionViewIndex].children[childIndex].inputError;
    const inputErrorMessage =
      quizQuestions[currentQuestionViewIndex].children[childIndex]
        .inputErrorMessage;
    setErrorMessage(inputError ? inputErrorMessage : "");
  }, [quizQuestions]);

  function decodeUserChoiceStr(str) {
    const codedStr = new URLSearchParams(str);

    const year = codedStr.get("year") || "";
    const make = codedStr.get("make") || "";
    const model = codedStr.get("model") || "";
    const trim = codedStr.get("trim") || "";

    if (!year || !make || !model) return str;

    return [year, make, model, trim].filter(Boolean).join(" ");
  }

  useEffect(() => {
    if (inputValue) {
      const inputValueWords = inputValue
        .split(" ")
        .map((word) => word.replace(/[^a-zA-Z0-9]/g, "").toLowerCase());

      // Helper to separate words and numbers
      const inputWordParts = {
        words: inputValueWords.filter((w) => isNaN(w)),
        numbers: inputValueWords.filter((w) => !isNaN(w)),
      };

      //1. strict search
      let updatedFilteredInventoryList = inventoryList
        .map((group, _) => {
          let updatedTrims = group.trims.filter((trim) => {
            let baseMatchStr = `${group.carName} ${trim}`;
            let trimmedBaseMatchStr = baseMatchStr
              .replace(/[^a-zA-Z0-9]/g, "")
              .toLowerCase();
            return inputValueWords.every((word) =>
              trimmedBaseMatchStr.includes(word)
            );
          });
          return updatedTrims?.length > 0
            ? {
                ...group,
                trims: updatedTrims,
              }
            : null;
        })
        .filter(Boolean);

      // 2. If strict search fails, try relaxed search
      if (updatedFilteredInventoryList.length === 0) {
        updatedFilteredInventoryList = inventoryList
          .map((group) => {
            let updatedTrims = group.trims.filter((trim) => {
              let baseMatchStr = `${group.carName} ${trim}`
                .replace(/[^a-zA-Z0-9]/g, "")
                .toLowerCase();
              return inputWordParts.words.every((word) =>
                baseMatchStr.includes(word)
              );
            });

            return updatedTrims.length > 0
              ? { ...group, trims: updatedTrims }
              : null;
          })
          .filter(Boolean);

        updatedFilteredInventoryList.push(getUserDropdownValue(inputValue));
      }

      setFilteredInventoryList(updatedFilteredInventoryList);
      return;
    }
    inventoryList?.length > 0
      ? setFilteredInventoryList(inventoryList)
      : setFilteredInventoryList([getUserDropdownValue(inputValue)]);
  }, [inputValue, inventoryList]);

  useEffect(() => {
    let currentInputValue =
      quizQuestions[currentQuestionViewIndex].children[childIndex].inputValue;
    currentInputValue = decodeUserChoiceStr(currentInputValue);
    setInputValue(currentInputValue);
  }, []);

  function filterInputValue(
    text,
    avgBaseMSRP = 0,
    fromInventory = false,
    valueFromDropdownSelected = false
  ) {
    const currentInputValue = decodeUserChoiceStr(text);

    setInputValue(currentInputValue);
    if (valueFromDropdownSelected) {
      handleVehicleVPOG(text);
      setQuizQuestions(
        produce((quizQuestionsDraft) => {
          const currentQuestionDraft =
            quizQuestionsDraft[currentQuestionViewIndex].children[childIndex];
          currentQuestionDraft.inputValue = fromInventory
            ? text
            : currentInputValue;
          currentQuestionDraft.inputFromInventory = fromInventory;
          currentQuestionDraft.avgBaseMSRP = avgBaseMSRP;
        })
      );
    } else {
      setQuizQuestions(
        produce((quizQuestionsDraft) => {
          const currentQuestionDraft =
            quizQuestionsDraft[currentQuestionViewIndex].children[childIndex];
          currentQuestionDraft.inputValue = "";
          currentQuestionDraft.inputFromInventory = fromInventory;
          currentQuestionDraft.avgBaseMSRP = 0;
        })
      );
    }
    setValueFromDropSelected(valueFromDropdownSelected);
  }

  return (
    <div className="quiz-input-container">
      <FormFieldWithLabel
        label={
          quizQuestions[currentQuestionViewIndex].children[childIndex]
            .inputLabel
        }
        type="text"
        id={
          quizQuestions[currentQuestionViewIndex].children[childIndex]
            .inputLabel
        }
        placeholder=""
        value={inputValue}
        onChange={(e) => {
          filterInputValue(e.target.value, 0, false, false);
        }}
        onFocus={openDropdown}
        onBlur={closeDropdown}
        errorMessage={errorMessage}
        required={
          quizQuestions[currentQuestionViewIndex].children[childIndex]
            .inputRequired
        }
        //disabled={inventoryListShow && inventoryListRequestPending}
      />
      {/* <div onClick={() => {
            filterInputValue('', false);
        }} className="clear_input_btn"> <X /> </div> */}
      {inventoryListShow && (
        <QuizInputList
          filteredInventoryList={filteredInventoryList}
          editAndFilterInputValue={filterInputValue}
          inventoryListRequestPending={inventoryListRequestPending}
          inventoryList={inventoryList}
        />
      )}
    </div>
  );
}
